import React from 'react';
import { NextPage } from 'next';

import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import Layout from '~/src/features/_layout';
import FullBuy from '~/src/features/full-buy';
import { ETariffFilters } from '~/src/features/full-buy/store/initialState';
import { initialProps } from '~/src/helpers/basePageFunc';
import { nonPermanentRedirect } from '~/src/helpers/url';
import type { TState } from '~/src/store';

interface IProps {
    currentCity: ICurrentCity,
    isVillage: boolean,
}

const FullBuyPage: NextPage<IProps> = ({ currentCity, isVillage }): JSX.Element => {
    const cityText = currentCity.cityIn;
    const title = `Пакет услуг в ${cityText}.`;
    const description = 'Выгодный интернет, цифровое ТВ в пакете.';

    return (
        <Layout
            title={title}
            description={description}
            withMenu={true}
            withFooter={true}
            withChat={false} // на странице свой чат
            bgColor={COLORS.BgMain}
        >
            <FullBuy
                isVillage={isVillage}
            />
        </Layout>
    );
};

FullBuyPage.getInitialProps = async(ctx): Promise<IProps> => {
    const { validatedAccessToken } = await initialProps(ctx, { isNeedAuthData: true });
    const { res, store, query } = ctx;

    const state: TState = store.getState();
    const { city: { currentCity } } = state;

    if (validatedAccessToken) {
        nonPermanentRedirect({ res, location: '/lk' });
        // @ts-ignore
        return {};
    }

    const isVillage = Boolean(query?.filters?.includes(ETariffFilters.COTTAGE));

    return {
        currentCity,
        isVillage,
    };
};

export default FullBuyPage;
